// extracted by mini-css-extract-plugin
export default {"singleElement":"DeleteEventModal_singleElement__CcbB1"};